import React from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from '@homeaway/react-date-pickers';
import cnames from 'classnames';
import { actionlocation } from '../TrendingModal/events';
import DatePickerIcon from '@homeaway/react-searchbox-lite/lib/transpiled/components/DatePickerIcon';
import DayAvailability from '@homeaway/react-searchbox-lite/lib/transpiled/components/DayAvailability';

import './DatePicker.less';

const DatePicker = ({ labels, locale, dpErrorMsg, isMobile, checkIn, checkOut, onDateRangeChange, onDateRangeClose, noDates }) => {
  const showContinueButton = !!(checkIn && checkOut);
  const dateRangeClassName = cnames('ModalDatePicker__range', {
    'ModalDatePicker__range--error': !!dpErrorMsg,
    'ModalDatePicker__range--disable': noDates,
    'ModalDatePicker__range--mobile': isMobile
  });

  return (
    <DateRangePicker
      id="trending-datepicker"
      clearButtonLabel = {labels.labels}
      locale={locale}
      showArrow={false}
      inputLabel1={labels.checkIn}
      inputLabel2={labels.checkOut}
      inputName1="checkin"
      inputName2="checkout"
      errorMsg={dpErrorMsg}
      startDate={checkIn}
      endDate={checkOut}
      onDateRangeChange={onDateRangeChange}
      onClose={onDateRangeClose}
      consolidateInputs={false}
      className={dateRangeClassName}
      showContinueButton={showContinueButton}
      readOnly={noDates}
      inputIcon1={<DatePickerIcon />}
      inputIcon2={<DatePickerIcon />}
      dayTemplateComponent={DayAvailability}
      actionLocation={actionlocation}
    />
  );
};

DatePicker.propTypes = {
  onDateRangeChange: PropTypes.func.isRequired,
  onDateRangeClose: PropTypes.func.isRequired,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  labels: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool.isRequired,
  dpErrorMsg: PropTypes.string,
  locale: PropTypes.string.isRequired,
  noDates: PropTypes.bool.isRequired
};


export default DatePicker;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/DatePicker/DatePicker.js